import React, { useState, useEffect, useContext } from "react";
import axios from "axios";
import Button from "@mui/material/Button";
import { makeStyles } from "@mui/styles";
import TextInput from "components/Input/TextInput.js";
import AutocompleteInput from "components/Input/AutocompleteInput.js";
import CustomSelect from "components/Input/CustomSelect.js";
import { compte } from "variables/patrimoine.js";
import AdvancedSearchContext from "context/AdvancedSearchContext";
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import UserService from "services/UserService";
import useEntitesTable from "./useEntitesTable.js";
import { getFiles, getSite } from "services/ConfigServices"

const useStyles = makeStyles((theme) => ({
  root: {
    "& .MuiTextField-root": {
      margin: '16px',
      marginTop: "1rem",
      backgroundColor: '#fff',
      //width: "30ch",
    },
  },
  formControl: {
    margin: '8px',
    minWidth: 120,
  },
  gridList: {
    width: 330,
    height: 400,
    //marginLeft: "-2rem",
  },
  tabs: {
    borderRight: `1px solid rgba(0, 0, 0, 0.12)`,
  },
  tab: {
    paddingLeft: "0rem",
    marginLeft: "0rem",
    flexDirection: "column",
    textAlign: "left",
    display: "grid",
    justifyContent: "left",
    alignItems: "flex-start",
    maxWidth: "3rem",
  },
  input: {
    display: "flex",
    flexDirection: "column",
    margin: "1rem 0rem 0rem",
  },
  inputTitle: {
    margin: "0.2rem 0rem 0.05rem 0.5rem",
  },
  select: {
    display: "flex",
    flexDirection: "column",
    margin: "1rem 0.5rem",
  },
  switch: {
    marginLeft: "0.5rem",
  },
}));

function EditUserDialog(props) {
  const { gridState } = useEntitesTable();
  const appContext = useContext(AdvancedSearchContext);
  const { chartIdGroup } = appContext;

  const [gedList, setGedList] = useState([
    { fileName: String, fileId: Number },
  ]);
  const [prevData, setPrevData] = useState();

  const {
    closeModal,
    refetch,
    idSelected,
    clef,
    comments,
    external,
    description,
    ged,
    email,
    name,
    status,
    role,
    company,
    phone,
    handleClefChange,
    handleCommentsChange,
    handleSelectValueChange,
    handleStatusChange,
    handleAssociatedfilesChange,
    handleEmailChange,
    handleNameChange,
    handleRoleChange,
    handleCompanyChange,
    handlePhoneChange,
    handleDescriptionChange,
  } = props;

  useEffect(() => {
    axios
      .get(
        getFiles(chartIdGroup),
        {
          headers: {
            Authorization: `Bearer ${UserService.getToken()}`,
          },
        }
      )
      .then((res) => {
        setGedList(res.data.collection);
      });
  }, []);

  useEffect(() => {
    axios
      .get(
        getSite(chartIdGroup, 'contact'),
        {
          headers: {
            Authorization: `Bearer ${UserService.getToken()}`,
          },
        }
      )
      .then((res) => {
        setPrevData(res.data.detail.contact?.contactlist);
      });
  }, []);

  const handleSubmit = async (event) => {
    const indexToReplace = prevData.findIndex((x) => x.uuid === idSelected);

    const newData = {
      clef,
      comments,
      external,
      description,
      ged,
      email,
      name,
      status,
      role,
      company,
      phone,
      'uuid': idSelected,
    };

    const contactlist = prevData;
    contactlist.splice(indexToReplace, 1, newData);

    axios
      .put(
        getSite(chartIdGroup, 'contact'),
        { contactlist },
        {
          headers: {
            Authorization: `Bearer ${UserService.getToken()}`,
            'Content-Type': "application/json; charset=utf-8",
          },
        }
      )
      .then(() => {
        closeModal();
        refetch();
      })
      .catch(() => { });
  };

  const selectedGed = () => {
    let gedCardId = [];
    let getGedNames;

    if (ged !== undefined) {
      for (let i = 0; i < ged.length; i++) {
        gedCardId.push(ged[i].fileId);
      }
      getGedNames = gedList.filter((gedList) =>
        gedCardId.includes(gedList.fileId)
      );
    }
    return getGedNames;
  };
  const externalData = [
    { id: "intern", name: "Interne" },
    { id: "extern", name: "Externe" },
    { id: "other", name: "Autres" },
  ];

  const classes = useStyles();

  return (
    <div>
      <form className={classes.root}>
        <GridContainer>
          <GridItem xs={12} sm={12} md={12} lg={12}>
            <div>
              <TextInput
                inputTitle={compte.contact.contactlist.name}
                textInput={name}
                handleTextInputChange={handleNameChange}
              />
            </div>
            <div>
              <TextInput
                inputTitle={compte.contact.contactlist.key}
                textInput={clef}
                handleTextInputChange={handleClefChange}
              />
            </div>
            <div>
              <TextInput
                inputTitle={compte.contact.contactlist.status}
                textInput={status}
                handleTextInputChange={handleStatusChange}
              />
            </div>
            <div>
              <TextInput
                inputTitle={compte.contact.contactlist.role}
                textInput={role}
                handleTextInputChange={handleRoleChange}
              />
            </div>
            <div>
              <TextInput
                inputTitle={compte.contact.contactlist.company}
                textInput={company}
                handleTextInputChange={handleCompanyChange}
              />
            </div>
            <div>
              <TextInput
                inputTitle={compte.contact.contactlist.phone}
                textInput={phone}
                handleTextInputChange={handlePhoneChange}
              />
            </div>
          </GridItem>
          <GridItem xs={12} sm={12} md={12} lg={12}>
            <div>
              <TextInput
                inputTitle={compte.contact.contactlist.email}
                textInput={email}
                handleTextInputChange={handleEmailChange}
              />
            </div>
            <div>
              <TextInput
                inputTitle={compte.contact.contactlist.comments}
                textInput={comments}
                handleTextInputChange={handleCommentsChange}
              />
            </div>

            <div>
              <CustomSelect
                inputTitle={compte.contact.contactlist.external}
                selectValue={external}
                handleSelectValueChange={handleSelectValueChange}
                data={externalData}
              />
            </div>

            <div style={{ width: "98%" }}>
              <AutocompleteInput
                inputTitle={compte.contact.contactlist.associatedfiles}
                selected={selectedGed()}
                list={gedList}
                handleChange={(_, newValue) =>
                  handleAssociatedfilesChange(newValue)
                }
              />
            </div>

            <div>
              <TextInput
                inputTitle={compte.contact.contactlist.description}
                textInput={description}
                handleTextInputChange={handleDescriptionChange}
              />
            </div>

            <Button
              noWrap
              style={{
                color: "#FFFFFF",
                backgroundColor: "#91C73C",
                fontWeight: "normal",
                fontWeight: "bold",
                height: "40px",
                fontSize: "0.75rem",
                padding: "5px 15px",
                marginRight: "0px",
                marginBottom: "0px",
                marginTop: "15px",
                fontFamily: '"Source Sans Pro",sans-serif',
                width: "96%",
                marginLeft: "2%",
              }}
              onClick={() => {
                handleSubmit();
              }}
            >
              Enregistrer
            </Button>
          </GridItem>
        </GridContainer>
      </form>
    </div>
  );
}

export default EditUserDialog;
